import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  toggle(event) {
    const item = event.currentTarget.closest("[data-accordion-target='item']")
    const answer = item.querySelector("[data-role='answer']")
    const icon = item.querySelector("[data-role='icon']")

    const isOpen = !answer.classList.contains("hidden")

    // Close all items
    this.itemTargets.forEach(i => {
      i.querySelector("[data-role='answer']").classList.add("hidden")
      i.querySelector("[data-role='icon']").classList.remove("rotate-180")
    })

    // Open clicked item if it was closed
    if (!isOpen) {
      answer.classList.remove("hidden")
      icon.classList.add("rotate-180")
    }
  }
}
